// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { TabletTab } from 'components/molecules/TabletTab';
import CompressionDelivery from 'components/organisms/CompressionDelivery';
import CompressionRegistration from 'components/organisms/CompressionRegistration';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import styles from './Compressions.module.scss';
import { Compression } from 'util/Types';
import Csv from 'util/csv';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';

function Compressions() {
  const { t } = useTranslation();
  const history = useHistory();
  const [isRefresh, setRefresh] = useState(false);
  const [tabIndex, setTabIndex] = useState<number>();
  const [exportingCompressions, setExportingCompressions] = useState<
    Compression[]
  >([]);
  const user = useSelector(selectUser);

  const handleExportCompressionDeliveryCsv = () => {
    new Csv({
      data: exportingCompressions,
      headers: [
        ['datetime', t('histories.label_csv_processed_date_time')],
        ['userName', t('common.person')],
        ['description', t('common.material_name')],
        ['grade.name', t('common.grade')],
        ['type', t('common.kind')],
        ['weight', t('common.weight') + ' (kg)'],
        ['compressionId', t('download.thead_volume_reduction_id')],
      ],
    }).downLoadCsv({
      filename: `${user.siteName}_${t('histories.processing_title')}`,
    });
  };

  return (
    <PrimaryTemplate
      h1={t('compressions.heading')}
      className={styles.container}
      download={tabIndex !== 1 ? undefined : handleExportCompressionDeliveryCsv}
    >
      <TabletTab
        tabItems={[
          t('compressions.tab_left_heading'),
          t('compressions.tab_right_heading'),
        ]}
        defaultTabIndex={history.location.hash == '#1' ? 1 : 0}
        setTabIndex={setTabIndex}
        renderContent={({ index }) => (
          <div>
            {index === 0 && (
              <CompressionRegistration
                setRefresh={setRefresh}
                isRefresh={isRefresh}
              />
            )}
            {index === 1 && (
              <CompressionDelivery
                setRefresh={setRefresh}
                isRefresh={isRefresh}
                setExportingCompressions={setExportingCompressions}
              />
            )}
          </div>
        )}
      />
    </PrimaryTemplate>
  );
}

export default Compressions;
